// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "single/assets/" + {"104":"d199359c4937cb3e5346","168":"822b8e0c4677a4dcde0e","303":"c1babd343b69c385711b","411":"62fcdcf86db23478ab6d","619":"e129bd3753c4a1949fee","956":"a7001e59c91cd7273c45"}[chunkId] + "." + chunkId + ".js";
};